export function addOrRemove(items, newItem) {
  if (items.includes(newItem)) {
    return items.filter((item) => item !== newItem);
  }
  return [...items, newItem];
}
